module.exports = __webpack_public_path__ + "img/L-600HS.0b859286.jpg";